import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { HeaderComponent } from './components/header/header.component';
// import { FooterComponent } from './components/footer/footer.component';
// import { NavmenuComponent } from './components/navmenu/navmenu.component';

import { HeaderComponent, FooterComponent, NavmenuComponent} from './components';

import { DatePipe } from '@angular/common'

import {NgxWebstorageModule} from 'ngx-webstorage';

import { SharedRoutingModule } from './shared-routing.module';

import { ApiService, DataService, ExcelService } from './services'

import { AuthInterceptor } from './interceptors/auth.interceptor';

import { PhoneMaskDirective } from './directives';
import { DescSlicePipe, YesOrNoPipe} from './pipes';
import { ConfirmPasswordValidator } from './validators';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';



@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavmenuComponent,
    PhoneMaskDirective,
    DescSlicePipe, 
    YesOrNoPipe, PrivacyPolicyComponent, TermsAndConditionsComponent,

  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    NgxWebstorageModule.forRoot(),
    SharedRoutingModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NavmenuComponent,
    PhoneMaskDirective,
    DescSlicePipe, 
    YesOrNoPipe,
],
providers: [
  ApiService,
  DataService,
  AuthInterceptor,
  ExcelService
],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
